import { http } from '../../../services/apiSecurity/Http.interceptor';
import { ResponsePagination } from '../../../core/interfaces/ResponsePagination';
import Group from './interfaces/Group';

const URL: string = '/grupos';

export const getGroups = (params?: any) => {
  return http.get<ResponsePagination>(URL, { params: params });
};

export const getByGroups = (id: number) => {
  return http.get<Group[]>(`${URL}/${id}`);
};

export const postGroups = (groups: Group) => {
  return http.post<Group>(URL, groups);
};

export const deleteGroups = (id: number) => {
  return http.delete<string>(`${URL}/${id}`);
};

export const putGroups = (groups: Group) => {
  return http.put<Group>(`${URL}/${groups.id}`, groups);
};
